var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_039_bulgaria",
    "data-name": "039 bulgaria",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1663",
    "data-name": "Path 1663",
    d: "M30,161.7a14.966,14.966,0,0,0-.933-5.217L15,155.826l-14.067.652a15.055,15.055,0,0,0,0,10.435L15,167.565l14.067-.652A14.967,14.967,0,0,0,30,161.7Z",
    transform: "translate(0 -146.696)",
    fill: "#496e2d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1664",
    "data-name": "Path 1664",
    d: "M29.99,354.826a15.005,15.005,0,0,0,14.067-9.783H15.923A15.005,15.005,0,0,0,29.99,354.826Z",
    transform: "translate(-14.99 -324.826)",
    fill: "#d80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1665",
    "data-name": "Path 1665",
    d: "M15.923,9.783H44.057a15.005,15.005,0,0,0-28.134,0Z",
    transform: "translate(-14.99)",
    fill: "#f0f0f0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/BG.294513aae4ebb773065a807130e6b946.svg";
export { ForwardRef as ReactComponent };